import {
  Boxes,
  Building2,
  Sofa,
  Package,
  PackageCheck,
  Warehouse,
  Briefcase,
  Clock,
  Trash2,
  KeyRound,
  Armchair,
  ShoppingBag,
} from "lucide-react";

// ---- Editable business config ----
export const business = {
  name: "Duke Summers Moving",
  futureName: "Duke Summers Moving & Logistics",
  primaryTagline: "A Name You Can Trust With Everything You Own.",
  legacyStatement: "Moving Lives. Moving Legacies.",
  secondaryTaglines: ["Strong Hands. Safe Moves.", "Your Home. Our Responsibility."],
  phone: "972-947-6017",
  email: "dukesummersmoving@gmail.com",
  hours: [
    { day: "Monday – Friday", time: "7:00 AM – 8:00 PM" },
    { day: "Saturday", time: "8:00 AM – 8:00 PM" },
    { day: "Sunday", time: "By appointment" },
  ],
};

// Editable service areas — add markets/cities anytime (scalable structure).
export const serviceAreaIntro =
  "Duke Summers Moving provides flexible moving assistance for local moves, apartment relocations, furniture moves, loading, unloading, and other moving needs in the communities we serve. Service availability may vary by location and job requirements.";

export const serviceAreas = [
  {
    region: "Dallas–Fort Worth Metroplex",
    cities: [
      "Dallas", "Fort Worth", "Arlington", "Irving", "Plano", "Garland",
      "Frisco", "McKinney", "Carrollton", "Denton", "Lewisville",
      "Mesquite", "Grand Prairie",
    ],
  },
  {
    region: "Memphis Metropolitan Area",
    cities: [
      "Memphis", "Cordova", "Southaven", "Olive Branch", "Hernando",
      "Collierville", "Bartlett", "Germantown",
    ],
  },
];

export const services = [
  {
    icon: Boxes,
    title: "Small Local Moves",
    desc: "Loading and unloading labor for studios, apartments, and smaller homes.",
    featured: true,
  },
  {
    icon: Building2,
    title: "Apartment & Condo Moves",
    desc: "Moving labor for apartments, condos, and other residential properties.",
  },
  {
    icon: Sofa,
    title: "Furniture Moving",
    desc: "Help moving individual furniture items in and out of homes, onto trucks, and into place.",
  },
  {
    icon: PackageCheck,
    title: "Loading & Unloading",
    desc: "Labor assistance for customers who have their own truck, trailer, rental vehicle, or moving container.",
  },
  {
    icon: Warehouse,
    title: "Storage Moves",
    desc: "Labor for loading belongings into or out of storage units.",
  },
  {
    icon: Briefcase,
    title: "Small Business & Office Moves",
    desc: "Moving labor for small offices and commercial spaces.",
  },
  {
    icon: Clock,
    title: "Short-Notice Assistance",
    desc: "When availability permits, we provide responsive help for customers who need to move quickly.",
  },
  {
    icon: Package,
    title: "Packing Help",
    desc: "Need help boxing things up? Our crew can pack your belongings using boxes and materials you provide. Billed at the standard hourly rate.",
  },
  {
    icon: Trash2,
    title: "Junk Removal",
    desc: "We clear out unwanted furniture, appliances, and clutter and load it to your curb, dumpster, or trailer. Competitive hourly pricing.",
  },
  {
    icon: KeyRound,
    title: "Eviction & Property Cleanouts",
    desc: "Fast, discreet cleanouts for landlords and property managers. We remove belongings and debris and load them into your dumpster or trailer. Competitive hourly pricing.",
  },
  {
    icon: Armchair,
    title: "Furniture Rearranging",
    desc: "Moving furniture room to room, upstairs, or just across the living room? No truck needed. Our crew handles the heavy lifting at the standard hourly rate.",
  },
  {
    icon: ShoppingBag,
    title: "Pickup Loading Help",
    desc: "Bought furniture or an appliance from a store or Facebook Marketplace? Bring the truck and we'll meet you there to load it, then unload and place it at home. Billed at the standard hourly rate.",
  },
];

export const futureServices = [
  "Larger residential moves",
  "Commercial relocation",
  "Packing & unpacking",
  "Storage solutions",
  "Logistics services",
];

// Numbered manifesto / why choose us
export const manifesto = [
  {
    n: "01",
    title: "Responsive Communication",
    body: "Clear, prompt answers from first message to final box. You always know what to expect.",
  },
  {
    n: "02",
    title: "Careful Handling",
    body: "Your furniture and belongings are treated with the same respect we'd give our own.",
  },
  {
    n: "03",
    title: "Right-Sized Service",
    body: "Flexible options for smaller and simpler moves that larger companies often overlook.",
  },
  {
    n: "04",
    title: "Transparent & Convenient",
    body: "Straightforward quotes and multiple convenient ways to pay. No surprises, no pressure.",
  },
];

export const payments = [
  "Cash",
  "Cash App",
  "Venmo",
  "PayPal",
  "Visa",
  "Mastercard",
  "Discover",
];

export const moveTypes = [
  "Small Local Move",
  "Apartment / Condo Move",
  "Furniture Moving",
  "Loading & Unloading Only",
  "Storage Move",
  "Small Business / Office Move",
  "Short-Notice / Same-Day",
  "Junk Removal",
  "Eviction Cleanouts",
  "Other",
];

export const images = {
  hero: "/hero.webp",
  aboutBoxes: "/about-furniture.jpg",
  servicesSofa: "/service-sofa.jpg",
  loadingVan: "https://images.pexels.com/photos/7464689/pexels-photo-7464689.jpeg?auto=compress&cs=tinysrgb&w=1600",
  skyline: "https://images.unsplash.com/photo-1580536793208-117fdb20ffc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};
